const countries = [
  {
    locale: "en-US",
    flag: require("@/assets/flags/united-states.svg"),
    name: "US",
  },
  {
    locale: "en-GB",
    flag: require("@/assets/flags/united-kingdom.svg"),
    name: "UK",
  },
  {
    locale: "de",
    flag: require("@/assets/flags/germany.svg"),
    name: "DE",
  },
];

export default countries;
